<template lang="pug">
  .leave-challenge
    .leave-challenge-header-container
      .leave-challenge-header
        span Leave Challenge?
      .leave-challenge-btn(@click="$emit('cancel')")
        WtSvgIcon(icon="cross-icon" width="28px" height="28px")
    .leave-challenge-body-container
      span.leave-text If you leave this challenge, your progress and data will be lost.
      button.btn-txt(
        @click="handleLeave"
        :disabled="isProcessing"
      ) {{ isProcessing ? 'Processing...' : 'Confirm' }}

</template>

<script>
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon.vue";

export default {
  name: "LeaveChallenge",
  components: { WtSvgIcon },

  data() {
    return {
      isProcessing: false
    };
  },

  methods: {
    handleLeave() {
      this.isProcessing = true;
      this.$emit("confirm");
    }
  }
};
</script>

<style lang="sass" scoped>
.leave-challenge
  width: 455px
  min-height: 207px
  background-color: #FFFFFF
  display: flex
  gap: 20px
  flex-direction: column
  border-radius: 16px
  max-width: 90vw
  margin: 0 auto
  position: relative

.leave-challenge-header-container
  display: flex
  padding: 20px 16px
  border-bottom: 1px solid #E8EBEF
  min-height: 68px
  justify-content: center

.leave-challenge-header
  display: flex
  align-items: center
  justify-content: center
  font-weight: 600
  font-size: 16px
  line-height: 24px

.leave-challenge-body-container
  display: flex
  flex-direction: column
  gap: 16px
  padding: 0px 16px 16px 16px
  word-break: break-word

.btn-txt
  font-weight: 600
  line-height: 24px
  letter-spacing: 0px
  background-color: #EC493F
  border-radius: 10px
  height: 40px
  max-width: 100%
  border: none
  color: white

.leave-text
  width: 100%
  font-weight: 400
  font-size: 14px
  line-height: 20px
  color: #1B1D20
  white-space: normal !important

.leave-challenge-btn
  position: absolute
  top: 12px
  right: 12px
</style>
